import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import _ from 'lodash';
import clsx from 'clsx';
import {
  withStyles,
  LinearProgress,
  Typography,
  makeStyles,
  Avatar,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

import { DashboardTickIcon, ROEmpty } from '../../../../constants';

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
  },
}))(LinearProgress);

const useStyles = makeStyles((theme) => ({
  job__card__container: {
    display: 'flex',
  },
  cursor__pointer: {
    cursor: 'pointer',
  },
  recent__count__para: {
    fontSize: '14px',
    lineHeight: '19px',
    color: '#6d7d8b',
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  recent__count__number: {
    fontWeight: '600',
    fontSize: '24px',
    lineHeight: '29px',
    color: '#29264a',
    padding: '0.5rem 0',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  status__label: {
    fontSize: '14px',
    lineHeight: '19px',
    color: '#6d7d8b',
    fontWeight: 'bold',
    paddingTop: '0.5rem',
  },
  status__list: {
    paddingTop: '0',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      '& svg': {
        display: 'none',
      },
    },
  },
  status: {
    paddingTop: '1rem',
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      height: '22px',
      width: '22px',
      '& rect': {
        fill: '#3a93ff',
      },
    },
    '&:nth-child(2)': {
      '& svg': {
        '& rect': {
          fill: '#ff4a55',
        },
      },
      '& .status__name': {
        background: '#ff4a55',
      },
    },
    '&:nth-child(3)': {
      '& svg': {
        '& rect': {
          fill: '#f59d4e',
        },
      },
      '& .status__name': {
        background: '#f59d4e',
        minWidth: '90px',
      },
    },
    '&:nth-child(4)': {
      '& svg': {
        '& rect': {
          fill: '#63cbce',
        },
      },
      '& .status__name': {
        background: '#63cbce',
      },
    },
  },
  status__name: {
    background: '#3a93ff',
    borderRadius: '20px',
    padding: '.8rem 1rem',
    height: '25px',
    marginLeft: '.5rem',
    fontWeight: '500',
    fontSize: '11px',
    lineHeight: '14px',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0',
      marginRight: '1rem',
      marginBottom: '1rem',
    },
  },
  empty__screen: {
    background: '#fff',
    borderRadius: '15px',
    // padding: '4rem 1rem 1rem',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '4rem 2.5rem',
  },
  empty__icon: {
    height: '115px',
    width: '150px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      width: '80%',
    },
  },
  empty__headings: {
    paddingLeft: '2.5rem',
  },
  main__text: {
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: '29px',
    color: '#6d7d8b',
    paddingBottom: '.5rem',
  },
  empty__text: {
    fontWeight: '400',
    fontSize: '14px',
    color: '#acc1d4',
    width: '72%',
  },
  empty__book__btn: {
    background: 'rgba(176, 151, 222, .3) !important',
    color: 'var(--color-primary)',
    borderRadius: '100px',
    padding: '0.5rem 1.5rem',
    textTransform: 'capitalize',
    marginTop: '1.2rem',
    boxShadow: 'none',
    '& svg': {
      '& path': {
        stroke: 'var(--color-primary)',
      },
    },
  },
  cards__details: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflowX: 'auto',
    width: 'calc(100% - 117px)',
    paddingLeft: '1rem',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
      width: 'calc(100%)',
    },
  },
  topbar: {
    borderRadius: '12px',
    margin: '',
    background: '#fff',
    display: 'flex',
    width: '100%',
  },
  list__item: {
    padding: '9px 2rem 9px 1rem',
    width: '25%',
    borderRight: '1px solid rgba(109, 125, 139, 0.2)',
    '&:nth-child(2)': {
      background: '#fff',
      '& .listitem__count': {
        color: '#ff4a55',
      },
    },
    '&:nth-child(3)': {
      background: '#fff',
      '& .listitem__count': {
        color: '#f59d4e',
      },
    },
    '&:nth-child(4)': {
      background: '#fff',
      '& .listitem__count': {
        color: '#63cbce',
      },
    },
    '&:last-child': {
      borderRight: 'none',
      background: '#fff',
      borderRadius: '0 12px 12px 0',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '215px',
    },
  },
  listitem__name: {
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '19px',
    color: '#29264a',
    textTransform: 'capitalize',
  },
  listitem__count: {
    fontSize: '20px',
    fontWeight: '600',
    lineHeight: '24px',
    textTransform: 'capitalize',
    color: '#3a93ff',
  },
  space__between: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  main__cards__container: {
    display: 'flex',
    width: '100%',
    padding: '1.5rem 0 0',
  },
  card__inner: {
    background: '#fff',
    padding: '1rem',
    margin: '0 auto',
    borderRadius: '20px',
    cursor: 'pointer',
  },
  progress__bar: {
    padding: '1.5rem 0 1rem',
    '& .MuiLinearProgress-bar': {
      background: '#3a93ff',
    },
    '& .MuiLinearProgress-root': {
      height: '5px',
      borderRadius: '10px',
    },
  },
  main__card: {
    width: '25%',
    padding: '0 .5rem',
    '&:nth-child(2)': {
      '& .progress__bar': {
        '& .MuiLinearProgress-bar': {
          background: '#ff4a55',
        },
      },
    },
    '&:nth-child(3)': {
      '& .progress__bar': {
        '& .MuiLinearProgress-bar': {
          background: '#f59d4e',
        },
      },
    },
    '&:nth-child(4)': {
      '& .progress__bar': {
        '& .MuiLinearProgress-bar': {
          background: '#63cbce',
        },
      },
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '215px',
    },
  },
  ro__number: {
    fontSize: '13px',
    paddingBottom: '.5rem',
    fontWeight: 'bold',
    color: '#263238',
  },
  customer__name: {
    fontSize: '13px',
    lineHeight: '16px',
    paddingBottom: '.5rem',
    fontWeight: '500',
    color: '#545b7d',
    textTransform: 'capitalize',
  },
  vehicle__info: {
    display: 'flex',
    padding: '.5rem 0',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '16px',
    color: '#6d7d8b',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '& .dot': {
      color: '#c4c4c4',
      padding: '0 5px',
    },
    '& .car__model': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      color: '#6d7d8b',
    },
  },
  order__stage: {
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '17px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '90%',
    color: '#29264a',
  },
  avatar__main: {
    width: '24px',
    height: '24px',
    fontSize: '10px',
  },
  cards__media: {
    '& .MuiAvatarGroup-avatar': {
      width: '24px',
      height: '24px',
      fontSize: '10px',
    },
  },
  card__date: {
    fontWeight: '600',
    fontSize: '13px',
    lineHeight: '16px',
    color: '#6d7d8b',
    width: '50%',
    '& svg': {
      fontSize: '15px',
    },
    '& .days': {
      paddingLeft: '.3rem',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
  },
  job__cards__main: {
    display: 'contents',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
  },
}));

export default function JobCard() {
  const [cardsData, setCardsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const history = useHistory();

  const jobCards = useSelector((state) => state.ro?.jobCards || []);
  const getJobCardsLoader =
    useSelector((state) => state.ro?.getJobCardsLoader) || false;

  useEffect(() => {
    const _cards = [];
    if (jobCards?.length) {
      jobCards.map((card) => {
        // first get the latest card based on date
        const latestCard = _.maxBy(card[card.name] || [], 'updatedAt') || '';

        // finding the progress bar value
        let totalHours = 0;
        let completedJobHours = 0;
        let progressSliderVal = 0;
        let ind = 0;
        const jobs = latestCard?.jobs || [];
        while (ind < jobs?.length) {
          totalHours += jobs[ind]?.totalHours || 0;
          if (jobs[ind]?.jobStatus === 'completed') {
            completedJobHours += jobs[ind]?.totalHours || 0;
          }
          ind++;
        }

        progressSliderVal = (completedJobHours / totalHours) * 100 || 0;

        _cards.push({
          ...card,
          itemData: latestCard,
          count: (card[card.name] || [])?.length || 0,
          progressBarValue: progressSliderVal,
        });
      });

      setTotalCount(_.sumBy(_cards, (o) => o.count) || 0);
      setCardsData(_cards);
    }
  }, [jobCards]);

  const classes = useStyles();

  const handleClickOnCard = (id) => {
    history.push(`jobboard/?tab=${id}`);
  };
  return (
    <>
      <div className={classes.job__card__main}>
        {getJobCardsLoader ? (
          <>
            <div className={classes.job__card__container}>
              <div className={classes.cards__info}>
                <Typography className={classes.recent__count__para}>
                  <Skeleton width={75} />
                </Typography>
                <Typography className={classes.recent__count__number}>
                  <Skeleton width={50} />
                </Typography>
                <Typography className={classes.status__label}>
                  <Skeleton width={60} />
                </Typography>
                <div className={classes.status__list}>
                  {[0, 1, 2, 3].map((label, i) => {
                    return (
                      <div className={classes.status} key={i++}>
                        <DashboardTickIcon />
                        <Typography
                          className={clsx(classes.status__name, 'status__name')}
                        >
                          <Skeleton />
                        </Typography>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className={classes.cards__details}>
                <div className={classes.topbar}>
                  {[0, 1, 2, 3]?.map((s, ind) => {
                    return (
                      <div
                        className={clsx(
                          classes.space__between,
                          classes.list__item,
                        )}
                        key={ind++}
                      >
                        <Typography className={classes.listitem__name}>
                          <Skeleton width={76} />
                        </Typography>
                        <Typography
                          className={clsx(
                            classes.listitem__count,
                            'listitem__count',
                          )}
                        >
                          <Skeleton width={20} />
                        </Typography>
                      </div>
                    );
                  })}
                </div>
                <div className={classes.main__cards__container}>
                  {[0, 1, 2, 3]?.map((item, index) => {
                    return (
                      <div className={classes.main__card} key={index++}>
                        <div className={classes.card__inner}>
                          <Typography className={classes.ro__number}>
                            <Skeleton width={90} />
                          </Typography>
                          <Typography className={classes.customer__name}>
                            <Skeleton width={60} />
                          </Typography>
                          <Typography className={classes.vehicle__info}>
                            <Skeleton width={40} />
                            <span className='dot'>•</span>
                            <Skeleton width={40} />
                          </Typography>
                          <Typography className={classes.order__stage}>
                            <Skeleton width={120} />
                          </Typography>
                          <div
                            className={clsx(
                              classes.progress__bar,
                              'progress__bar',
                            )}
                          >
                            <BorderLinearProgress
                              variant='determinate'
                              value={20}
                            />
                          </div>
                          <div
                            className={clsx(
                              classes.cards__footer,
                              classes.space__between,
                            )}
                          >
                            <div className={classes.cards__media}>
                              <AvatarGroup max={3}>
                                {item?.mechanics?.map((mechanic) => {
                                  return (
                                    <Avatar
                                      className={classes.avatar__main}
                                      alt='A'
                                      src={mechanic.profileImg}
                                    />
                                  );
                                })}
                              </AvatarGroup>
                            </div>
                            {item?.date && (
                              <div className={classes.card__date}>
                                <AccessTimeIcon />
                                <Typography className='days'>
                                  {item.date}
                                </Typography>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className={classes.job__card__container}>
            {totalCount <= 0 ? (
              <div className={classes.empty__screen}>
                <div className={classes.empty__icon}>
                  <ROEmpty />
                </div>
                <div className={classes.empty__headings}>
                  <Typography className={classes.main__text}>
                    Create Repair Order
                  </Typography>
                  <Typography className={classes.empty__text}>
                    Repair Orders you create will show up here along with the
                    recent Job Board activity.
                  </Typography>
                </div>
              </div>
            ) : (
              <div className={classes.job__cards__main}>
                <div className={classes.cards__info}>
                  <Typography className={classes.recent__count__para}>
                    Recent Job Cards
                  </Typography>
                  <Typography className={classes.recent__count__number}>
                    {totalCount || 0}
                  </Typography>
                  <Typography className={classes.status__label}>
                    Status:
                  </Typography>
                  <div className={classes.status__list}>
                    {cardsData.map((label) => {
                      return (
                        <div className={classes.status}>
                          <DashboardTickIcon />
                          <Typography
                            className={clsx(
                              classes.status__name,
                              'status__name',
                            )}
                          >
                            {label.name === 'New Repair Order'
                              ? 'New RO'
                              : label.name}
                          </Typography>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className={classes.cards__details}>
                  <div
                    className={clsx(classes.topbar, classes.cursor__pointer)}
                  >
                    {cardsData?.map((s, i) => {
                      return (
                        <div
                          className={clsx(
                            classes.space__between,
                            classes.list__item,
                          )}
                          onClick={() => handleClickOnCard(i + 1)}
                        >
                          <Typography className={classes.listitem__name}>
                            {s?.name}
                          </Typography>
                          <Typography
                            className={clsx(
                              classes.listitem__count,
                              'listitem__count',
                            )}
                          >
                            {s?.count || 0}
                          </Typography>
                        </div>
                      );
                    })}
                  </div>
                  <div className={classes.main__cards__container}>
                    {cardsData?.map((item, i) => {
                      return item.itemData ? (
                        <div className={classes.main__card}>
                          <div
                            className={classes.card__inner}
                            onClick={() => handleClickOnCard(i + 1)}
                          >
                            {item?.itemData?.repairOrderId && (
                              <Typography className={classes.ro__number}>
                                RO-{item.itemData.repairOrderId}
                              </Typography>
                            )}
                            <Typography className={classes.customer__name}>
                              {item?.itemData?.customer?.name}
                            </Typography>
                            <Typography className={classes.vehicle__info}>
                              {item?.itemData?.vehicle?.vehicleModel || ''}
                              <span className='dot'>•</span>
                              <span className='car__model'>
                                {item?.itemData?.vehicle?.licensePlate || ''}
                              </span>
                            </Typography>
                            <Typography className={classes.order__stage}>
                              {item?.itemData?.orderStage}
                            </Typography>
                            <div
                              className={clsx(
                                classes.progress__bar,
                                'progress__bar',
                              )}
                            >
                              <BorderLinearProgress
                                variant='determinate'
                                value={item?.progressBarValue || 0}
                              />
                            </div>
                            <div
                              className={clsx(
                                classes.cards__footer,
                                classes.space__between,
                              )}
                            >
                              <div className={classes.cards__media}>
                                <AvatarGroup max={3}>
                                  {item?.mechanics?.map((mechanic) => {
                                    return (
                                      <Avatar
                                        className={classes.avatar__main}
                                        alt='A'
                                        src={mechanic.profileImg}
                                      />
                                    );
                                  })}
                                </AvatarGroup>
                              </div>
                              {item?.date && (
                                <div className={classes.card__date}>
                                  <AccessTimeIcon />
                                  <Typography className='days'>
                                    {item.date}
                                  </Typography>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className={classes.main__card}>{/* Empty */}</div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
